import  { FC, useState, useRef } from "react"
import Button from '@mui/material/Button'
import AddressComponent from "@pages/makeEvent/steps-components/address-component"
import EventDateComponent from "@pages/makeEvent/steps-components/eventDate-component"
import { DateAndLocationTabPanelProps } from '@/pages/eventEditing/components/types'

type FieldsNames = "start_time" | "end_time" | "event_address" 

const DateAndLocationTabPanel: FC<DateAndLocationTabPanelProps> = ({ formik }) => {
	const { values } = formik
	const initialValues = {
		"start_time": values["start_time"],
		"end_time": values["end_time"],
		"event_address": values["event_address"]
	}
	const [validFieldsValues, setValidFieldsValues] = useState({initialValues})
	const preservedInitialValues = useRef(initialValues)


	const setValidValue = (name: FieldsNames) => (value) => {
		setValidFieldsValues({...validFieldsValues, [name]: value})
	}

	return (
		<div style={{display: 'flex', flexDirection: 'column', gap: '8px'}}>
			<EventDateComponent formik={formik} setValidValue={setValidValue}/>
			<AddressComponent formik={formik} setValidAddress={setValidValue("event_address")}/>
		</div>
	)
}

export default DateAndLocationTabPanel